<div class="cx-item-list-header row">
  <div class="cx-item-list-desc">
    {{ 'uigCartItems.description' | cxTranslate }}
  </div>
  <div class="cx-item-list-price">
    {{ 'uigCartItems.itemPrice' | cxTranslate }}
  </div>
  <div class="cx-item-list-qty">
    {{ 'uigCartItems.quantity' | cxTranslate }}
  </div>
  <div class="cx-item-list-total">
    {{ 'uigCartItems.total' | cxTranslate }}
  </div>
</div>

@for (entryGroup of vendorEntryGroups; track entryGroup) {
  <div class="row vendor-name">
    <div class="col-md-12">{{('vendorGroups.vendor' | cxTranslate) +": "+ entryGroup.vendorName}}</div>
  </div>
  <app-uig-cart-item-list [cartId]="cartId" [items]="entryGroup.entries" [cartIsLoading]="cartIsLoading"
  [promotionLocation]="promotionLocation" [readonly]="readonly" [options]="options" [savedCarts]="savedCarts"></app-uig-cart-item-list>
  <div class="row vendor-note">
    <div class="col-md-7 note-text">
      @if (entryGroup?.noteText) {
        <span class="header">{{('vendorGroups.note' | cxTranslate)}}: </span>
        <span [innerHTML]="entryGroup?.noteText | safeHtml"></span>
      }
    </div>
    <div class="col-md-5 subtotal">
      <span class="header">{{('vendorGroups.vendorTotal' | cxTranslate) +" "+ entryGroup.vendorName}}: </span>
      <span class="sum">{{entryGroup?.totalPrice?.value | currency:entryGroup?.totalPrice?.currencyIso:"symbol":"1.2-2":"de"}}</span>
    </div>
  </div>
}